/**
 * @author Ariel
 * @description 消息通知详情页面
 * @Date 2021/06/24
 */
import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import {templateConfig, reduxTemplateConfig} from './config';
import './index.less'

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool
let { WizRow, WizCol, WizCard,WizBizcharts, WizTooltip} = component_tool
let {Session} = utils_tool
const { Chart, Geom, Axis, Tooltip, Coord, Legend,Guide,Label } = WizBizcharts;

const _getValue = (type, key) => {
  const values = {
    bizType: {
      0: '课程',
      1: '考试',
      15: '报名',
      23: '活动',
      26: '直播',
      38: '任务',
    },
    sendType: {
      0: '站内通知',
      1: '推送通知',
      3: '短信通知',
      4: '邮件通知',
      5: '企业微信',
      6: '语音通话',
    },
    sendStatus: {
      0: '待推送',
      1: '推送成功',
      2: '推送失败'
    }
  }
  return values[type][key]
}

class NoticeRecordDetail extends WizContainer {
  componentName = 'noticeRecordDetail'

  constructor(props) {
    super(props)
    const {history} = props
    let record = {};
    if (history.location && history.location.pathname === '/message/noticeRecord/noticeRecordDetail') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('record', record)
      } else {
        record = Session.get('record') || {}
      }
    }
    this.record = record
    this.filters = {}
    this.state = {
      bizId: record.bizId,
      bizType: record.bizType,
      sceneName: record.sceneName,
      bizName: record.bizName
    }
  }

  _componentDidMount() {
    if (this.record && this.record.id > 0) {
      this._getRecordPicList();
    }
  }

  _getRecordPicList(apiParams = {}) {
    let {bizId, bizType, sceneName} = this.state
    this.doAction({
      path: 'messageNoticeRecord/recordPic',
      payload: {
        key: 'recordPic',
        apiParams: {
          bizId: bizId,
          bizType: bizType,
          sceneName: sceneName
        }
      }
    })
  }

  _renderPic = (val, index) => {
    let {sendType, personCount, infos} = val
    let sendTypeName = _getValue("sendType", sendType)
    const { Html } = Guide;
    let infoList = [
      {sendStatus:1,personNum:0,percent:0,color:'green'},
      {sendStatus:2,personNum:0,percent:0,color:'red'},
      {sendStatus:0,personNum:0,percent:0,color:'yellow'},
    ]
    infoList.forEach(e => {
      infos.map(info => {
        if (e.sendStatus === info.sendStatus) {
          e.personNum = info.personNum
        }
      })
    })
    const data = infoList.map(info => {
      return {item: _getValue('sendStatus',info.sendStatus), count: info.personNum, percent: info.personNum/personCount,color:info.color }
    })

    const cols = {
      percent: {
        formatter: val => (val = `${val}%`)
      }
    }
    return (
      <WizCol span={8}>
      <Chart
        width={300}
        height={200}
        data={data}
        scale={cols}
        padding="auto"
      >
        <Coord type="theta" radius={0.75} innerRadius={0.7}/>
        <Axis name="percent" />
        <Legend position='right-center'
                textStyle={{
                  textAlign: 'start', // 文本对齐方向，可取值为： start middle end
                  fill: 'black', // 文本的颜色
                  fontSize: '12', // 文本大小
                  textBaseline: 'middle' // 文本基准线，可取 top middle bottom，默认为middle
                }}
                itemFormatter={val => {
                  let p = 0;
                  let c = 0;
                  data.forEach(d => {
                    if (d['item'] === val) {
                      if (personCount === 0) {
                        personCount = 1;
                      }
                      p = (d['count'] * 100 / personCount).toFixed(2) + "%"
                      c = d['count']
                    }
                  });
                  return val + '  ' + p + '  ' + c; // val 为每个图例项的文本值
                }}
        />
        <Tooltip showTitle={false}
                 itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
        />
        <Guide>
          <Html
            position={["50%", "50%"]}
            html={() => {
              return `<div style="text-align:center;font-size:1em">${sendTypeName}<br/><span style="color:black;font-size:1.5em">${personCount}</span></div>`;
            }}
            alignX="middle"
            alignY="middle"
          />
        </Guide>
        <Geom
          type="intervalStack"
          position="percent"
          color={['item',['#43cf7c','#ff5733','#ffc300']]}
          tooltip={[
            "item*percent",
            (item, percent) => {
              percent = (percent * 100).toFixed(2) + "%";
              return {
                name: item,
                value: percent
              };
            }
          ]}
          style={{
            lineWidth: 1,
            stroke: '#fff',
          }}
        />
      </Chart>
      </WizCol>
    )
  }

  _render() {
    let {bizId, bizType,bizName, sceneName} = this.state
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({bizId: bizId, bizType: bizType, sceneName: sceneName}),
      apiDataFormat: {},
      bizId, bizType, sceneName
    })
    let {recordPic} = this.props
    return (
      <React.Fragment>
        <WizCard title={'通知概况'}>
          <WizRow>
            <WizCol offset={1} span={7}><strong>业务类型:  </strong>{_getValue("bizType",bizType)}</WizCol>
            <WizCol offset={1} span={7}><WizTooltip className='notice-record-detail' title={bizName}>
              <div className='notice-record-detail' >
                <strong>业务内容:  </strong>{bizName}
              </div>
            </WizTooltip></WizCol>
            <WizCol offset={1} span={7}><strong>通知场景:  </strong>{sceneName}</WizCol>
          </WizRow>
          <WizRow>
          {
            recordPic.code === 1 ? recordPic.data.map((val,index) => this._renderPic(val,index)) : null
          }
          </WizRow>
        </WizCard>
        <WizCard title={'通知记录'}>
          <WizReduxTemplate {..._reduxTemplateConfig}/>
        </WizCard>
      </React.Fragment>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  let {messageNoticeRecord} = state
  const recordPic = modelUtils.getModelEntity(messageNoticeRecord, 'recordPic');
  const load = modelUtils.getLoadingState(state, 'messageNoticeRecord')
  return {
    recordPic,
    ...load
  }
};

export default connect(mapStateToProps)(NoticeRecordDetail);
